const INIT_STATE = {
    isModalActive: false
  }
  
  export function AboutModalReducer(state=INIT_STATE, action) {
    switch (action.type) {
      case 'ABOUT_MODAL_RESET':
        return {...INIT_STATE};
      case 'ABOUT_MODAL_SHOW':
        return {...state, isModalActive: true};
      case 'ABOUT_MODAL_HIDE':
        return {...state, isModalActive: false};
      case 'ABOUT_MODAL_TOGGLE':
        return {...state, isModalActive: !state.isModalActive};
      default:
        return state;
    }
  }
  